import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/development/real-estate/kanban/$cardId/')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/development/real-estate/kanban/$cardId/general',
      params,
      replace: true,
      search,
    })
  },
})
